<template>
  <div class="eBook-page">
    <header>
      <div class="top-bar">
        <img
          src="@/assets/jkt/logoJKT.png"
          alt="JKT Logo"
          class="logo"
        >
        <div class="nav-links">
          <RouterLink
            to="/"
            exact-active-class="active"
          >
            <i class="fas fa-chart-bar" /> UTAMA
          </RouterLink>
          <RouterLink
            to="/login"
            exact-active-class="active"
          >
            <i class="fas fa-circle-user" /> LOG MASUK
          </RouterLink>
        </div>
      </div>
      <div class="welcome-text">
        <h1>JKTGATEWAY E-BOOK</h1>
        <hr class="underline">
      </div>
    </header>
    <div
      id="gallery"
      class="gallery"
    >
      <div class="image-card">
        <RouterLink
          class="image-inner"
          :to="{ path: '/books' }"
          target="_blank"
        >
          <img
            src="./img/one.png"
            alt=""
          >
        </RouterLink>
        <div class="image-info">
          <h5 class="title">
            PIHAK BERKUASA TEMPATAN (PBT)
          </h5>
          <p>Edisi 2023</p>
          <p>Rujukan ringkas mengenai dasar-dasar berkaitan</p>
          <p>
            Jabatan Kerajaan Tempatan Aras 26-29, No 51 Persiaran Perdana Presint
            4 621000 W.P, Putra Jaya Malaysia
          </p>
          <button>Muat Turun PDF</button>
        </div>
      </div>

      <div class="image-card">
        <RouterLink
          class="image-inner"
          :to="{ path: '/books' }"
          target="_blank"
        >
          <img
            src="./img/two.png"
            alt=""
          >
        </RouterLink>
        <div class="image-info">
          <h5 class="title">
            PIHAK BERKUASA TEMPATAN (PBT)
          </h5>
          <p>Edisi 2024</p>
          <p>Rujukan ringkas mengenai dasar-dasar berkaitan</p>
          <p>
            Jabatan Kerajaan Tempatan Aras 26-29, No 51 Persiaran Perdana Presint
            4 621000 W.P, Putra Jaya Malaysia
          </p>
          <button>Muat Turun PDF</button>
        </div>
      </div>

      <div class="image-card">
        <RouterLink
          class="image-inner"
          :to="{ path: '/books' }"
          target="_blank"
        >
          <img
            src="./img/three.png"
            alt=""
          >
        </RouterLink>
        <div class="image-info">
          <h5 class="title">
            PIHAK BERKUASA TEMPATAN (PBT)
          </h5>
          <p>Edisi 2025</p>
          <p>Rujukan ringkas mengenai dasar-dasar berkaitan</p>
          <p>
            Jabatan Kerajaan Tempatan Aras 26-29, No 51 Persiaran Perdana Presint
            4 621000 W.P, Putra Jaya Malaysia
          </p>
          <button>Muat Turun PDF</button>
        </div>
      </div>
    </div>
  </div>
  <Menu />
</template>

<script setup>
import Menu from '@/components/menu-items/utama-menu.vue'

// Added by Abdullah
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

// Composition API setup
import { useRouter } from 'vue-router'

const router = useRouter()

const navigateTo = path => {
  router.push(path)
}
</script>

<style scoped>
.eBook-page {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-attachment: fixed;
  background-image: url("@/assets/jkt/eBookBack.png");
  background-position: center;
  background-size: cover;
  color: white;
  min-block-size: 100vh;
}

header {
  z-index: 2;
  padding: 10px;
  inline-size: 100%;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 10px;
  padding-inline: 20px;
}

.logo {
  block-size: 30px;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #312867;
  font-size: 1rem;
  text-decoration: none;
}

.nav-links a:hover {
  text-decoration: underline;
}

.welcome-text {
  margin-block-start: 40px; /* Adjust this value to move the text down */
  text-align: center;
}

.welcome-text h1 {
  color: #2f5596;
  font-size: 5rem;
  font-weight: bold;
}

.gallery {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 20px;
}

.image-card {
  background: white;
  color: #312867;
  border-radius: 10px;
  padding: 15px;
  margin: 10px;
  width: 300px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.image-inner img {
  max-inline-size: 100%;
  border-radius: 10px;
}

.image-info {
  margin-top: 10px;
  text-align: center;
}

.image-info h5 {
  font-size: 1.2rem;
  font-weight: bold;
}

.image-info p {
  margin: 5px 0;
}

.image-info button {
  background-color: #2f5596;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.image-info button:hover {
  background-color: #1d3b70;
}

@media (max-width: 768px) {
  .welcome-text h1 {
    font-size: 3rem;
  }

  .nav-links {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .nav-links a {
    font-size: 0.9rem;
  }

  h1 {
    font-size: 1.5rem;
  }

  .gallery {
    flex-direction: column;
    align-items: center;
  }

  .image-card {
    width: 90%;
    margin-inline: auto;
  }
}

@media (max-width: 480px) {
  .nav-links {
    flex-direction: column;
    align-items: flex-start;
  }

  .nav-links a {
    font-size: 0.8rem;
  }

  .welcome-text h1 {
    font-size: 2.5rem;
  }

  .logo {
    block-size: 25px;
  }
}
</style>
